var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"black--text align-self-center"},[_vm._v(" "+_vm._s(_vm.label.SeedPackLabel)+" ")]),_c('delete-icon',{staticClass:"white ml-4",attrs:{"elevation":"2","color":"red"},on:{"on-delete":_vm.removeLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }